import React from "react";
import syntappzLogo from "../images/syntappz-logo.png";
import CTAButton from "./CTAButton";

const Footer = () => {
  const openPortfolio = () =>
    window.open("https://syntappz.herokuapp.com/", "_blank");

  return (
    <div className="footer">
      <div className="container">
        <div className="flex-footer">
          <div className="logo-wrap">
            <div className="syntappz-logo">
              <img src={syntappzLogo} alt="syntappz logo" />
            </div>
          </div>

          <div className="footer-description">
            <div>
              <h3>Developer Links</h3>
              <div className="line"></div>
              <a href="https://syntappz.herokuapp.com/">My Portfolio</a>
              <a href="https://github.com/SyntappZ">My Github</a>
              <a href="https://play.google.com/store/apps/developer?id=SyntappZ">
                Android Playstore
              </a>
              <a href="mailto:syntappz@gmail.com">Email Me</a>
            </div>
          </div>
        </div>

        <p className="copy">Wizafy &copy; 2021</p>
      </div>
    </div>
  );
};

export default Footer;
